// Create a const where all members have a readonly value
// and literal type by using const assertion.
const HTag = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
};
Object.values(HTag);

export { HTag as H };
